import { render, staticRenderFns } from "./_entries.vue?vue&type=template&id=93585c80&v-if=fetch_data&"
import script from "./_entries.vue?vue&type=script&lang=js&"
export * from "./_entries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports